
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import { ValidationObserver } from 'vee-validate';
import { JwtStore, BlockStore, SensorStore, FarmStore } from '@/store/modules';

@Component({
  meta: {
    title: 'Login'
  },
  components: {
    QvInput,
    ValidationObserver
  }
})
export default class Login extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  isPwd = true;
  username = '';
  password = '';

  created() {
    if (
      process.env.NODE_ENV === 'development' &&
      process.env.VUE_APP_PRESET_LOGIN
    ) {
      // this.username = 'anish@pathway.com.np';
      // this.password = 'aoeusnth';
      this.username = 'fruitsmap@pathway.com.np';
      this.password = 'FruitsM@p';
    }
  }

  async onSubmit() {
    // eslint-disable-next-line
    await JwtStore.getJWT({
      username: this.username.toLowerCase(),
      password: this.password
    });

    await FarmStore.setFetchingDefaultFarm(true);
    await FarmStore.getMyDefaultFarm();

    BlockStore.getAllMyBlocks();
    // BlockStore.getAllMyBlocksWithGeom();
    SensorStore.getSensors();
    this.$router.push({ name: 'Home' });
  }
  onReset() {
    this.username = '';
    this.password = '';
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }
}
